import { render } from "./AlertItem.vue?vue&type=template&id=42d66b9d&scoped=true"
import script from "./AlertItem.vue?vue&type=script&lang=js"
export * from "./AlertItem.vue?vue&type=script&lang=js"

import "./AlertItem.vue?vue&type=style&index=0&id=42d66b9d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d66b9d"]])

export default __exports__